// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const FIREBASE_API = {
    apiKey: "AIzaSyCYp4odAQN_QKho46B3sniL0bBny86dF9I",
    authDomain: "smoke-24.firebaseapp.com",
    databaseURL: "https://smoke-24-default-rtdb.firebaseio.com",
    projectId: "smoke-24",
    storageBucket: "smoke-24.appspot.com",
    messagingSenderId: "698603643149",
    appId: "1:698603643149:web:a3b2ed4e04a54aedf6d044",
    measurementId: "G-6FSMDVJ2ND"
};

// basename: only at build time to set,
// and Don't add '/' at end off BASENAME for breadcrumbs,
// also Don't put only '/' use blank('') instead,
// like '/berry-material-react/react/default'
export const BASE_PATH = '';

export const DASHBOARD_PATH = '/track-orders';

const config = {
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 8,
    outlinedFilled: true,
    navType: 'light', // light, dark
    presetColor: 'default', // default, theme1, theme2, theme3, theme4, theme5, theme6
    locale: 'en', // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
    rtlLayout: false,
    container: false
};

export default config;
